module.exports = __webpack_public_path__ + "img/335.26acd8bf.jpg";